module.exports = __webpack_public_path__ + "static/media/mapp-logo.9cf26ea0.svg";